// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".managerTrackControllHeader_head__ywukU {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: #464646;\n  -webkit-user-select: none;\n          user-select: none; }\n\n.managerTrackControllHeader_root__2ZxCl {\n  margin-bottom: 10px;\n  margin-top: 8px; }\n\n.managerTrackControllHeader_creator__2T49T {\n  display: grid;\n  grid-template-columns: 50px 40px 2fr 100px 1.5fr 1fr; }\n\n.managerTrackControllHeader_manager__dXwm8 {\n  display: grid;\n  grid-template-columns: 50px 40px 2fr 100px 1.5fr 0.5fr 0.5fr; }\n\n.managerTrackControllHeader_sorting__2WObU {\n  font-weight: bold; }\n", ""]);
// Exports
exports.locals = {
	"head": "managerTrackControllHeader_head__ywukU",
	"root": "managerTrackControllHeader_root__2ZxCl",
	"creator": "managerTrackControllHeader_creator__2T49T",
	"manager": "managerTrackControllHeader_manager__dXwm8",
	"sorting": "managerTrackControllHeader_sorting__2WObU"
};
module.exports = exports;
